import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Gem } from "lucide-react";
import { Link } from "wouter";

export interface Offer {
  name: string;
  payout: number;
}

export interface OfferwallCardProps {
  provider: string;
  icon: React.ReactNode;
  description: string;
  totalOffers: number;
  color: string;
  offers: Offer[];
  link: string;
}

const OfferwallCard = ({ provider, icon, description, totalOffers, color, offers, link }: OfferwallCardProps) => {
  return (
    <motion.div
      whileHover={{ y: -5, transition: { type: "spring", stiffness: 300 } }}
      className="h-full"
    >
      <Card className={`glass-effect h-full flex flex-col border-border overflow-hidden`}>
        <CardHeader className="flex-row items-center gap-4 pb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center bg-gradient-to-br ${color}`}>
                {icon}
            </div>
            <div>
                <CardTitle className="text-lg">{provider}</CardTitle>
                <p className="text-sm text-muted-foreground">{description}</p>
            </div>
        </CardHeader>
        <CardContent className="flex-grow flex flex-col justify-between pt-0">
            <div>
                <div className="text-xs text-muted-foreground mb-3 font-medium">TOP OFFERS</div>
                <div className="space-y-2 mb-4">
                    {offers.slice(0, 2).map((offer) => (
                        <div key={offer.name} className="flex items-center justify-between text-sm p-2 rounded-md bg-secondary/20">
                            <span className="truncate text-muted-foreground text-xs">{offer.name}</span>
                            <div className="flex items-center gap-1.5 text-green-400 font-bold text-xs">
                                <Gem className="w-3 h-3" />
                                {offer.payout.toLocaleString()}
                            </div>
                        </div>
                    ))}
                     {offers.length === 0 && (
                        <div className="text-center text-xs text-muted-foreground py-2">No offers to display.</div>
                    )}
                </div>
            </div>
            <Link href={link}>
                <Button className="w-full glow-effect font-semibold" size="sm">
                    View all {totalOffers} offers
                </Button>
            </Link>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default OfferwallCard;
